'use client';
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './styles.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faInstagram,
  faFacebook,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import { faX } from '@fortawesome/free-solid-svg-icons';

const Footer = () => {
  return (
    <footer
      id="contact"
      className="transparent text-white py-4"
      style={{
        paddingBottom: '0 !important',
      }}
    >
      <Container>
        <Row>
          <Col md={4}>
            <div
              className="footer-text-heading"
              data-aos="zoom-out"
              data-aos-offset="0"
            >
              CONTACT US
            </div>

            <p data-aos="fade-in" data-aos-offset="0">
              Office Address: <br />
              No. 6 / 858 - M, 2nd Floor, <br />
              Suite # 967, Vallamkottil Towers, <br />
              Judgemukku, Thrikkakara P.O, <br />
              Kakkanad, Ernakulam, <br />
              Kerala - 682021
            </p>
          </Col>
          <Col md={4}>
            <div
              className="footer-text-heading"
              data-aos="zoom-out"
              data-aos-offset="0"
            >
              QUICK LINKS
            </div>
            <ul className="list-unstyled quik-links">
              <li data-aos="fade-in" data-aos-offset="0">
                <a href="/#" className="text-white">
                  Home
                </a>
              </li>
              <li data-aos="fade-in" data-aos-offset="0">
                <a href="/#gallery" className="text-white">
                  Gallery
                </a>
              </li>
              <li data-aos="fade-in" data-aos-offset="0">
                <a href="/#news" className="text-white">
                  News
                </a>
              </li>
              <li data-aos="fade-in" data-aos-offset="0">
                <a href="/#membership" className="text-white">
                  Memberships
                </a>
              </li>
              <li data-aos="fade-in" data-aos-offset="0">
                <a href="/#results" className="text-white">
                  Fixtures & Results
                </a>
              </li>
              {/* <li data-aos="fade-in" data-aos-offset="0">
                <a href="/chants" className="text-white">
                  Chants
                </a>
              </li> */}
            </ul>
          </Col>
          <Col md={4}>
            <div
              className="footer-text-heading"
              data-aos="zoom-out"
              data-aos-offset="0"
            >
              GET IN TOUCH
            </div>
            <h5></h5>
            <div className="social-media">
              <ul className="list-unstyled quik-links ">
                <li data-aos="fade-in" data-aos-offset="0">
                  <a
                    href="https://www.instagram.com/kbfc_manjappada"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon icon={faInstagram} size="1x" /> Instagram
                  </a>
                </li>
                <li data-aos="fade-in" data-aos-offset="0">
                  <a
                    href="https://www.facebook.com/manjappadaKBFCfans"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon icon={faFacebook} size="1x" /> Facebook
                  </a>
                </li>
                <li data-aos="fade-in" data-aos-offset="0">
                  <a
                    href="https://x.com/kbfc_manjappada"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon icon={faX} size="1x" /> X(Twitter)
                  </a>
                </li>
                <li data-aos="fade-in" data-aos-offset="0">
                  <a
                    href="https://www.youtube.com/@kbfc_manjappada"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon icon={faYoutube} size="1x" /> Youtube
                  </a>
                </li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
      <div
        style={{
          width: '100%',
          height: '1rem', // or any height you want
          background: 'linear-gradient(90deg, #001335 0%, #0040B2 100%)',
        }}
      ></div>
      <Col className="text-center" style={{ marginTop: '1rem', padding: 0 }}>
        <p>
          &copy; 2024 Manjappada. All rights reserved. Powered by{' '}
          <a
            href="https://www.webcurve.in/"
            style={{
              textDecoration: 'none',
              color: 'white',
            }}
          >
            <strong>Webcurve</strong>
          </a>
        </p>
      </Col>
    </footer>
  );
};

export default Footer;
